import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Log desactivado - usar [ANIMATION TYPE] y [OVERLAY CREATED]
    // Inicializar estado
    this.isNavigating = false
    this.pendingUrl = null
    this.overlayElement = null

    this.setupTurboListeners()
    // Asegurarse de que el scroll restoration manual esté activo
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
  }

  disconnect() {
    this.removeTurboListeners()
    this.removeOverlay()
  }

  setupTurboListeners() {
    this.turboBeforeVisitHandler = this.handleBeforeVisit.bind(this)
    this.turboLoadHandler = this.handleLoad.bind(this)
    document.addEventListener("turbo:before-visit", this.turboBeforeVisitHandler)
    document.addEventListener("turbo:load", this.turboLoadHandler)
  }

  removeTurboListeners() {
    document.removeEventListener("turbo:before-visit", this.turboBeforeVisitHandler)
    document.removeEventListener("turbo:load", this.turboLoadHandler)
  }

  handleLoad() {
    const exitFlag = sessionStorage.getItem('news_exit_transition_active')
    const enterFlag = sessionStorage.getItem('news_enter_transition_active')

    // Si hay transición de salida activa, NO hacer nada de entrada
    if (exitFlag === 'true') {
      return
    }

    // Verificar si hay una transición de entrada activa en sessionStorage
    const isEnterTransitionActive = enterFlag === 'true'

    // Si estamos en una página de artículo y es una navegación de entrada, mostrar animación de revelado
    if (this.isArticlePage() && isEnterTransitionActive) {
      // console.log('[ENTER] article page detectada, iniciando revelado', { timestamp: new Date().toISOString() })
      // Limpiar el estado de sessionStorage
      // console.log('[ENTER] sessionStorage.removeItem news_enter_transition_active', { timestamp: new Date().toISOString() })
      sessionStorage.removeItem('news_enter_transition_active')

      // Destruir el overlay de entrada antes de mostrar el revelado
      this.removeOverlay()
      // Mostrar animación de revelado
      this.showRevealAnimation()
    }
    // Resetear flag de navegación
    this.isNavigating = false
    // console.log('[ENTER] isNavigating reset to false', { timestamp: new Date().toISOString() })
  }

  navigate(event) {
    // console.log('[ENTER] direct navigate action', { timestamp: new Date().toISOString() })
    if (!event.currentTarget) return

    const targetUrl = event.currentTarget.getAttribute("href") || event.currentTarget.dataset.url
    if (!targetUrl) return

    const isExitTransitionActive = sessionStorage.getItem('news_exit_transition_active') === 'true'

    if (this.isArticleNavigation(targetUrl) && !this.isNavigating && !isExitTransitionActive) {
      event.preventDefault()

      this.isNavigating = true
      this.pendingUrl = targetUrl

      sessionStorage.setItem('news_enter_transition_active', 'true')

      this.scrollY = window.scrollY

      this.showOverlay()

      setTimeout(() => {
        Turbo.visit(targetUrl, { action: 'advance' })
      }, 1600)
    }
  }

  handleBeforeVisit(event) {
    // console.log('[ENTER] turbo:before-visit', { timestamp: new Date().toISOString() })
    // Solo activar overlay para navegaciones a artículos
    const targetUrl = event.detail.url
    // console.log('[ENTER] url detectada', { url: targetUrl, timestamp: new Date().toISOString() })
    // Verificar que no sea una transición de salida
    const isExitTransitionActive = sessionStorage.getItem('news_exit_transition_active') === 'true'
    // console.log('[ENTER] sessionStorage news_exit_transition_active', { value: isExitTransitionActive, timestamp: new Date().toISOString() })

    if (this.isArticleNavigation(targetUrl) && !this.isNavigating && !isExitTransitionActive) {
      // console.log('[ENTER] iniciando transición de entrada', { timestamp: new Date().toISOString() })
      // Prevenir la navegación inmediata
      event.preventDefault()

      // Marcar que estamos navegando para evitar bucles
      // console.log('[ENTER] isNavigating: false -> true', { timestamp: new Date().toISOString() })
      this.isNavigating = true
      this.pendingUrl = targetUrl

      // Guardar estado en sessionStorage para persistir después de la navegación
      // console.log('[ENTER] sessionStorage.setItem news_enter_transition_active = true', { timestamp: new Date().toISOString() })
      sessionStorage.setItem('news_enter_transition_active', 'true')

      // Guardar scroll actual
      this.scrollY = window.scrollY
      // console.log('[ENTER] saveScrollPosition', { scrollY: this.scrollY, timestamp: new Date().toISOString() })

      // Mostrar overlay
      this.showOverlay()

      // Esperar a que termine la animación de entrada (600ms) + 1 segundo
      // Luego ejecutar la navegación manualmente
      setTimeout(() => {
        // console.log('[ENTER] navegación programada ejecutada', { url: targetUrl, timestamp: new Date().toISOString() })
        // Usar Turbo.visit para mantener el scroll
        Turbo.visit(targetUrl, { action: 'advance' })
      }, 1600)
    }
  }

  isArticleNavigation(url) {
    // Verificar si la URL es una navegación a artículo
    const parsedUrl = new URL(url, window.location.origin)
    // Aceptar URLs como /categoria/noticias/tipo/id/slug o /noticias/tipo/id/slug
    return parsedUrl.pathname.match(/\/noticias\/[^/]+\/\d+\/[^/]+$/) || parsedUrl.pathname.match(/\/[^/]+\/noticias\/[^/]+\/\d+\/[^/]+$/)
  }

  isArticlePage() {
    // Verificar si la página actual es un artículo (incluyendo videos y galerías)
    const pathname = window.location.pathname
    return pathname.match(/\/noticias\/[^/]+\/\d+\/[^/]+$/) ||
           pathname.match(/\/[^/]+\/noticias\/[^/]+\/\d+\/[^/]+$/) ||
           pathname.match(/\/noticias\/video\/\d+\/[^/]+$/) ||
           pathname.match(/\/[^/]+\/noticias\/video\/\d+\/[^/]+$/)
  }

  saveScrollPosition() {
    const key = `scroll:${window.location.pathname}`
    sessionStorage.setItem(key, window.scrollY.toString())
  }

  showOverlay() {
    // Log desactivado - simplificado
    if (this.overlayElement) {
      // console.log('[ENTER] overlay ya existe, retornando', { timestamp: new Date().toISOString() })
      return
    }

    // Guardar posición actual del scroll
    this.scrollY = window.scrollY

    // Bloquear scroll del body sin cambiar position (evita salto al inicio)
    document.body.style.overflow = "hidden"

    // Buscar el elemento header para calcular su altura
    const headerElement = document.querySelector('header')
    const headerHeight = headerElement ? headerElement.offsetHeight : 0

    // Crear overlay
    this.overlayElement = document.createElement("div")
    this.overlayElement.className = "news-enter-transition-overlay"
    this.overlayElement.style.cssText = `
      position: fixed;
      top: ${headerHeight}px;
      bottom: 0;
      left: 0;
      right: 0;
      height: calc(100vh - ${headerHeight}px);
      background: black;
      z-index: 40;
      transform: scaleY(0);
      transform-origin: bottom;
      transition: transform 600ms ease-out;
      pointer-events: auto;
    `
    this.overlayElement.id = `enter-overlay-${Date.now()}`
    document.body.appendChild(this.overlayElement)

    // Crear indicador de carga
    const loader = document.createElement("div")
    loader.className = "news-enter-transition-loader"
    loader.style.cssText = `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      gap: 16px;
      align-items: center;
    `

    // Rectángulo azul
    const blueRect = document.createElement("div")
    blueRect.className = "news-enter-transition-rect-blue"
    blueRect.style.cssText = `
      width: 80px;
      height: 5px;
      background: #3b82f6;
      border-radius: 2px;
      animation: pulse-blue 1.5s ease-in-out infinite;
    `

    // Rectángulo blanco
    const whiteRect = document.createElement("div")
    whiteRect.className = "news-enter-transition-rect-white"
    whiteRect.style.cssText = `
      width: 80px;
      height: 5px;
      background: white;
      border-radius: 2px;
      animation: pulse-white 1.5s ease-in-out infinite;
    `

    loader.appendChild(blueRect)
    loader.appendChild(whiteRect)
    loader.id = `loader-${Date.now()}`
    this.overlayElement.appendChild(loader)
    // Loader creado - ID asignado para tracking

    // Agregar estilos de animación
    const style = document.createElement("style")
    style.textContent = `
      @keyframes pulse-blue {
        0%, 100% { width: 80px; opacity: 1; }
        50% { width: 40px; opacity: 0.5; }
      }
      @keyframes pulse-white {
        0%, 100% { width: 40px; opacity: 0.5; }
        50% { width: 80px; opacity: 1; }
      }
    `
    document.head.appendChild(style)

    // Forzar reflow para que la transición funcione
    this.overlayElement.offsetHeight

    // Animación de panel ascendente (abajo → arriba)
    this.overlayElement.style.transform = "scaleY(1)"
  }

  removeOverlay() {
    // Eliminar el overlay principal si existe
    if (this.overlayElement) {
      this.overlayElement.remove()
      this.overlayElement = null
    }

    // Limpieza agresiva: buscar cualquier elemento de transición de entrada en el DOM
    const selectors = [
      '.news-enter-transition-overlay',
      '.news-enter-transition-loader',
      '.news-enter-transition-rect-blue',
      '.news-enter-transition-rect-white',
      '[id^="enter-overlay-"]',
      '[id^="loader-"]'
    ]
    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.remove()
      })
    })

    // Restaurar scroll del body
    document.body.style.overflow = ""
  }

  // Método para loggear todos los overlays/loaders en el DOM - desactivado
  logDomOverlays(context) {
    // Método desactivado - usado solo para debugging
  }

  showRevealAnimation() {
    // Buscar el elemento header para calcular su altura
    const headerElement = document.querySelector('header')
    const headerHeight = headerElement ? headerElement.offsetHeight : 0

    // Crear overlay de revelado
    const revealOverlay = document.createElement("div")
    revealOverlay.className = "news-enter-transition-reveal"
    revealOverlay.id = `reveal-${Date.now()}`
    // Overlay creado
    revealOverlay.style.cssText = `
      position: fixed;
      top: ${headerHeight}px;
      bottom: 0;
      left: 0;
      right: 0;
      height: calc(100vh - ${headerHeight}px);
      background: black;
      z-index: 40;
      transition: opacity 1000ms ease-out;
      pointer-events: none;
    `
    document.body.appendChild(revealOverlay)
    // console.log('[ENTER] reveal overlay creado', { timestamp: new Date().toISOString() })

    // Forzar reflow
    revealOverlay.offsetHeight

    // Animación de revelado
    setTimeout(() => {
      revealOverlay.style.opacity = "0"

      // Remover overlay después de la animación
      setTimeout(() => {
        revealOverlay.remove()
        // console.log('[ENTER] reveal overlay eliminado', { timestamp: new Date().toISOString() })
      }, 1000)
    }, 100)
  }
}
